<template>
  <div id="manage">
    <div class="content">
        <div class="title">首页推荐</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <Select v-model="platform_id" placeholder="请选择" class="borDiv" style="width:200px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="search(1)">
                            <Option v-for="item in platform_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                    <div class="fl_right addClass" @click="addRecruit">新增推荐</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading" :draggable="true" @on-drag-drop="setWorkSort"></Table>
                </div>
                <!-- <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page> -->
            </div>
            <div class="alertBox" v-if="alertShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">推荐人群<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Select v-model="platform_id_sel" placeholder="请选择" class="borDiv" style="width:440px;border:1px solid #e7e7eb;">
                                    <Option v-for="item in platform_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">类型<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <RadioGroup v-model="leixin" @on-change="getQi(3)">
                                    <Radio v-for="(item,index) in leiList" :label="item.id" :key="item.id">{{item.name}}</Radio>
                                </RadioGroup>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">推荐内容<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Select v-if="leixin=='754a7162vx84bd6v92c1'" v-model="qishu" class="bordiv" placeholder="请选择" filterable style="width:440px;margin-right:10px;height:36px;">
                                    <Option v-for="item in qishuList" :key="item.id" :value="item.id">{{ item.name}}</Option>
                                </Select>
                                <Input v-else v-model="url" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入" />
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">图片<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <div class="file-list">
                                    <div class="urlLogo urlLogo1" >
                                        <img :src="imgd1" alt="" v-if="imgd1">
                                        <div class="add" v-if="!imgd1"></div>
                                        <input type="file" id="file1" multiple="false" @change="doUpload(1)"/>
                                    </div>
                                </div>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tanBtn" @click="tanyes(valm)">确定</div>
                </div>
            </div>
            <div class="alertBox" v-show="cropShow" style="padding-top: 8%">
                <div style="background: #fff;width: 600px;height: 445px;margin:0 auto;
                padding-top: 20px;">
                    <div class="cropper">
                        <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :fixedBox="option.fixedBox"
                        >
                        </vueCropper>
                    </div>
                    <div style="width: 300px;margin: 0 auto;">
                        <div class="fl_left tanBtn tanBtned tanBtneds" @click="delCrop">取消</div>
                        <div class="fl_right tanBtn tanBtneds" @click="upload('base64')">确认裁剪</div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                url:'',
                canpany_name:'',
                address:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                UPload:false,
                cropShow:false,
                qishu:'',
                qishuList:[],
                leixin:'754a7162vx84bd6v92c1',
                leiList:[],
                option: {
                    img: '',//剪切图片地址
                    size: 1,//输出图片压缩比默认为1
                    full: false,//输出截图是否缩放
                    outputType: 'jpg',//输出图片格式
                    canMove: true,//是否可以拖动图片
                    fixedBox: true,//是否固定截图大小
                    original: false,//上传图片按原始比例
                    canMoveBox: false,//是否可以拖动截图框
                    autoCrop: true,//是否自成截图框
                    // 只有自动截图开启 宽度高度才生效
                    autoCropWidth: 484,//截图框宽
                    autoCropHeight: 308,//截图框高
                    centerBox: false,//截图框能否超过图片
                    high: true//是否根据dpr输出高清图片
                },
                columns7: [
                    {
                        title: '',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: 'ios-move'
                                    },
                                    style:{
                                      cursor: 'all-scroll'
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '推荐人群',
                        align: 'center',
                        key: 'platform_name',
                    },
                    {
                        title: '图片',
                        align: 'center',
                        key: 'title',
                        render: (h, params) => {
                            return h('img',{
                                            style:{
                                                width:'150px',
                                                height:'95px'
                                            },
                                            domProps: {
                                                src:params.row.cover
                                            }
                                        })
                        }
                    },
                    {
                        title: '类型',
                        align: 'center',
                        key: 'type_name',
                    },
                    {
                        title: '推荐内容',
                        align: 'center',
                        key: 'obj_name',
                        render: (h, params) => {
                            return h('div',params.row.type_name=='网页'?params.row.url:params.row.obj_name)
                        }
                    },
                    {
                        title: '是否推荐',
                        align: 'center',
                        key: 'uphone',
                        render: (h, params) => {
                            let _this = this
                            return h('div',[
                                h('i-switch', {
                                    props: {
                                        value: params.row.status==1, 
                                        size:'default',
                                        disabled:this.disabled,
                                    },
                                    nativeOn: { 
                                        click:() => { //值发生了改变调用方法
                                            this.$axios.post('changerecommendstatus',{id:params.row.id}).then(res=>{
                                                if(res.data.code==200){
                                                    this.search(0)
                                                    this.$Message.success('操作成功');
                                                    // if(params.row.enroll_status==1){
                                                    //     this.$Message.success('关闭成功');
                                                    // }
                                                    // if(params.row.enroll_status==0){
                                                    //     this.$Message.success('开启成功');
                                                    // }
                                                 }
                                                 else{
                                                     this.$Message.error(res.data.message);
                                                     // this.disabled=true;
                                                     this.search(0)
                                                 }
                                            }).catch(function (error) {
                                              console.log(error);
                                            });
                                        }
                                    }
                                },
                                [
                                    h('span',{
                                        slot:'open',
                                        domProps:{
                                            innerHTML:'是'
                                        }, 
                                    }),
                                    h('span',{
                                        slot:'close',
                                        domProps:{
                                            innerHTML:'否'
                                        }, 
                                    })
                                ])
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginRight:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.getLeixin();
                                                _this.getplatform(1);
                                                _this.platform_id_sel=params.row.platform;
                                                _this.leixin=params.row.type;
                                                _this.qishu=params.row.obj_id;
                                                _this.file_url1=params.row.cover;
                                                _this.imgd1=params.row.cover;
                                                _this.url=params.row.url;
                                                _this.cate_id=params.row.id;
                                                _this.valm=1;
                                                _this.alertShow=true;
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除？</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deleterecommend',{id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('删除成功');
                                                                _this.search(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
                clnum:1,
                imgd1:'',
                file_url1:'',
                cate_id:'',
                platform_list:[],//推荐类型
                platform_id:'',
                platform_id_sel:'',
            }
        },
        methods:{
            //只修改 form 和 to之间的排序
            setWorkSort(form, to) {
                form   = parseInt(form)
                to     = parseInt(to)
     
                let tmp = this.data6[form]

                //重置排序
                this.sortData   = [];
                //向上冒泡
                if(form < to) {
                    for(var i=form+1; i<=to; i++) {
                        this.data6.splice(i-1, 1, this.data6[i])
                        this.sortData.push({recommend_id:this.data6[i].id,tsort:i})
                    }
                    this.data6.splice(to, 1, tmp)
                    this.sortData.push({recommend_id:tmp.id,tsort:i})
                }
                //向下浮沉
                if(form > to) {
                    for(var i=form; i>to; i--) {
                        this.data6.splice(i, 1, this.data6[i-1])
                        this.sortData.push({recommend_id:this.data6[i-1].id,tsort:i})
                    }
                    this.data6.splice(to, 1, tmp)
                    this.sortData.push({recommend_id:tmp.id,tsort:i})
                }

                this.$axios.post('setrecommendsort', {sort_data:this.sortData}).then(res => {
                    if (res.data.code == 200) {
                        this.$Message.success("排序成功");
                    }
                    else {
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //点击上传图片事件
            doUpload(index){
                let _this = this;
                _this.clnum=index;
                if(index==1){
                    var files = document.getElementById('file1');
                    var fileLen = document.getElementById('file1').files;
                    var filename=$('#file1').val();
                    // _this.uploadByOss(fileLen[0])
                    // _this.option.autoCropWidth=241;//截图框宽
                    // _this.option.autoCropHeight=337;//截图框高
                    // _this.option.img=URL.createObjectURL(fileLen[0]);
                    // _this.cropShow=true;
                    _this.imgd1=URL.createObjectURL(fileLen[0]);
                    _this.uploadByOss(fileLen[0])
                    $('#file1').val('')
                }
            },
            //图片地址
            upload(type){
                let _this=this;
                _this.$refs.cropper.getCropData((dataURL) => {
                    let base64 = dataURL.split(',')[1];
                    let fileType = dataURL.split(';')[0].split(':')[1];
                    let blob = this.toBlob(base64,fileType);
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (event) {
                        var file = new File([blob],new Date().getTime()+'.'+blob.type.split('/')[1],{type: "image/png"})
                        _this.uploadByOss(file)
                        if(_this.clnum==1){
                            _this.imgd1=dataURL;
                        }
                    }

                })
            },
            //裁剪弹窗隐藏
            delCrop(){
                this.cropShow=false;
            },
            //二进制转换
            toBlob(urlData,fileType){
                var bytes=window.atob(urlData),
                    n=bytes.length,
                    u8arr=new Uint8Array(n);
                while(n--){
                    u8arr[n]=bytes.charCodeAt(n);
                }
                return new Blob([u8arr],{type:fileType});
            },
            random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                } 
                return pwd;
            },
            //阿里云上传
            uploadByOss(file){
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl =new Date().getTime() + _this.random_string(16)+'.'+file.name.split('.')[1]
                return new Promise(function(resolve , reject){  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('policyaction').then(function(res){
                         var re = res.data.data;
                         var osssignature = {
                            'key' : re.dir+fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status' : '200', 
                            'signature': re.signature,
                            'callback':re.callback,
                        };
                        var formData = new FormData()
                        for( var k in osssignature ){
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                                loading.close();
                                if(_this.clnum == 1){
                                    _this.file_url1 = xhr.responseURL + re.dir + fileurl;
                                    _this.cropShow=false;
                                }
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }             
                    })
                })
            },            
            //确定提交
            tanyes(index){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.leixin===''){
                    this.$Message.error('请选择类型');
                }
                else if(_this.leixin=='754a7162vx84bd6v92c1'&&_this.qishu===''){
                    this.$Message.error('请选择期数');
                }
                else if(_this.leixin=='4c7a8162vx84bd6v95ce'&&_this.url===''){
                    this.$Message.error('请输入推荐内容');
                }
                else if(_this.file_url1==''){
                    this.$Message.error('请添加图片');
                }
                else{
                    if(index==0){
                        _this.$axios.post('addrecommend',{
                            type:_this.leixin,
                            obj_id:_this.qishu,
                            cover:_this.file_url1,
                            url:_this.url,
                            platform:_this.platform_id_sel,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                    if(index==1){
                        _this.$axios.post('editrecommend',{
                            type:_this.leixin,
                            obj_id:_this.qishu,
                            cover:_this.file_url1,
                            id:_this.cate_id,
                            url:_this.url,
                            platform:_this.platform_id_sel,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                }
            },
            tandel(){
                this.alertShow=false;
            },
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getrecommendlist',{
                    page:_this.pageNum,
                    page_size:_this.pageSize,
                    platform:_this.platform_id
                }).then(res=>{
                    if(res.data.code==200){
                        // _this.total=res.data.data.total;
                        _this.data6=res.data.data;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                _this.valm=0;
                _this.getLeixin(0);
                _this.imgd1='';
                _this.url='';
                _this.file_url1='';
                _this.getplatform(0);
                _this.alertShow=true;
            },
            getLeixin(index){
                let _this=this; 
                _this.$axios.post('getrecommendtype',{}).then(res=>{
                    if(res.data.code==200){
                        _this.leiList=res.data.data;
                        if(index==0){
                            _this.leixin=res.data.data[0].id;
                        }
                        _this.getQi(index);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getQi(index){
                let _this=this; 
                if(index==3){
                    _this.url='';
                }
                _this.$axios.post('getrecommendobjectlist',{type:_this.leixin}).then(res=>{
                    if(res.data.code==200){
                        if(index==0||index==3){
                            _this.qishu=res.data.data[0].id;
                        }
                        _this.qishuList=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getplatform(index){
                let _this=this; 
                _this.$axios.post('getrecommendplatform',{}).then(res=>{
                    if(res.data.code==200){
                        _this.platform_list=res.data.data;
                        if(index==0){
                            _this.platform_id_sel=res.data.data[0].id;
                        }
                        if(index==2){
                            _this.platform_id=res.data.data[0].id;
                            _this.search(1);
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this; 
            _this.getplatform(2);
            // _this.search(1);
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
    .add {
        width: 200px;
        height: 136px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/upload.jpg) no-repeat;  /*// 这里使用的是我本地图片*/
        background-size: 100% 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/peizhi/index.vue